import React, { useCallback } from 'react';
import * as adminConfigService from '../../../services/adminConfigService'

const useAdminConfig = () => {

    const findConfig = useCallback(async (code: string) => {
        try {
            const response = await adminConfigService.findAdminConfig(code);
            const roleData = response.data;
            return roleData;
        } catch (error) {
            console.error("Failed to fetch admin config:", error);
            throw error; 
        }
    }, []);

    return {
        findConfig
    };
};

export default useAdminConfig;
